const MyMessage = ({ message }) => {
    if (message.attachments && message.attachments.length > 0) {
        return (
            <img
                src={message.attachments[0].file}
                alt="message-attachment"
                className="message-image"
                style={{ float: 'right' }}
            />
        );
    }

    return (
        <div className="message myMessage" style={{ textAlign: 'right', float: 'right', marginRight: '18px', color: 'white', backgroundColor: '#47b5d6' }}>
            {message.text}
        </div>
    );
};

export default MyMessage;
